export const stepper = {
    active: { color: '#3699ff', fill: '#3699ff' },
    inactive: { color: '#B5B5C3', fill: '#B5B5C3' }
}
